(function ($) {
    'use strict';

    $(function () {
        var $carousel = $('.brokercode-tiles--carousel');
        if ($carousel.length === 0 || typeof $carousel.owlCarousel !== 'function') {
            return;
        }

        var itemCount = $carousel.children().length;
        var maxItems = 4;
        var shouldLoop = itemCount > maxItems;
        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var showNav = itemCount > 1;
        var showDots = itemCount > 1;

        // Initialize the broker logo carousel.
        $carousel.owlCarousel({
            loop: shouldLoop,
            rewind: !shouldLoop,
            margin: 16,
            nav: showNav,
            dots: showDots,
            navText: [
                '<span class="material-symbols-outlined" aria-hidden="true">chevron_left</span>',
                '<span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>'
            ],
            autoplay: shouldLoop && !prefersReducedMotion,
            autoplayTimeout: 4500,
            autoplayHoverPause: true,
            responsive: {
                0: { items: 1 },
                480: { items: 2 },
                900: { items: 3 },
                1200: { items: 4 }
            }
        });
    });
})(jQuery);